import { OrgIdContext } from "../../../store/orgId_context";
import { tx } from "../../../lib/ddd/ddd";
import { NavLink } from "react-router-dom";
import { useContext } from "react";
import classes from "./IntegrationComponentsFull.module.scss"
import { ReactComponent as NpmIcon } from "../../../assets/npmIcon.svg";
import { ReactComponent as Logo } from "../../../assets/logo.svg";

const JSHowTo = () =>{
    const {  integrationDevice } = useContext(OrgIdContext);
    return(
        <>
        1. To send requests to our service, you can use whatever technology can send HTTPS POST/GET requests. But for the purpose of JavaScript we will use two
        external libraries to help with sending requests. One of the libraries is the popular axios HTTP client library for browsers and node.js
        <div className="mt-4">
            You can download the library from:
            <table className={`${classes["links-table"]} w-100 table`}>
                <tbody >
                    <tr>
                        <td><Logo style={{width:"2rem", height:"2rem"}}/></td>
                        <td><NavLink to={`https://${window.location.hostname}/content/3rdparty/axios-1.4.0.min.js`} target="_blank">https://{window.location.hostname}/content/3rdparty/axios-1.4.0.min.js</NavLink></td>
                    </tr>
                    <tr>
                        <td><NpmIcon style={{width:"2rem", height:"2rem"}}/></td>
                        <td><NavLink to="https://www.npmjs.com/package/axios" target="_blank">https://www.npmjs.com/package/axios</NavLink></td>
                    </tr>
                    
                </tbody>
            </table>
        </div>
        <div className="mt-2">
            2. The second library we will use is a helper library that we also use with all our services and is designed specifically to work with our APIs.
            This library is not necessary, but it is recommended. All the examples will make use of this library.
        </div>
        <div className="mt-4">
            You can download the library from:
            <table className={`${classes["links-table"]} w-100 table`}>
                <tbody >
                    <tr>
                        <td><Logo style={{width:"2rem", height:"2rem"}}/></td>
                        <td><NavLink to={`https://${window.location.hostname}/content/jsonrpc-2.0.js`} target="_blank">https://{window.location.hostname}/content/jsonrpc-2.0.js</NavLink></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div className="mt-4">3. The request needs three pieces of information:</div>
        <ol style={{paddingLeft:"1rem", paddingTop:"1rem"}}>
            <li>Identification (&lt;connectionKey&gt;)</li>
            <li>API endpoint (&lt;api-name&gt;)</li> 
            <li>Data (&lt;parameters&gt;)</li>
        </ol>
        Here is an example such of a request:
        <div className={classes["code-snippet"]}>
                RpcClient.config.url = "https://{window.location.hostname}.online/json.rpc"<br/>
                RpcClient.config.headers = &#123;&#125;;<br/>
                RpcClient.config.headers['Authorization'] = 'IoT <span className={classes.red}>&lt;connectionKey&gt;</span>:EUeInvoices';<br/>
                RpcClient.call("Extension.Execute", &#123; extension: "EUeInvoices.<span className={classes.red}>&lt;api-name&gt;</span>", args: <span className={classes.red}>&lt;parameters&gt;</span> &#125;)<br/>
                <span className="ps-2">.done(res =&gt; &#123;<br/></span>
                <span className="ps-4">console.log(res);<br/></span>
                <span className="ps-4">&#125;)<br/></span>
                <span className="ps-2">.post()</span>
        </div>
        You will use the below <u>Integration Key</u> to learn and test the integration with our service. It is also used for all requests triggered by the 
        learning playground. All invoices sent with this key can be viewed in the "Integration -&gt; {tx("DDDI_Save")} -&gt; <NavLink to="/sent-integration-invoices">Sent invoices</NavLink>" menu (if the sending was 
        successful, at least to the extent that the object was accepted for processing).
        <div className={classes["code-snippet"]} >{integrationDevice}</div>
        <div className="alert alert-warning">
        Note! This is not a key intended to be used for your company's actual invoices. You can find the key that belongs to your company 
        in your company profile. Start using your company's key (called Connection Key) only when you've already finished testing integration.
        </div>
        And finally, for this we will be using the "{tx("EUeInvoices.DDDI_Save")}" API endpoint, making our request the following:
        <div className={classes["code-snippet"]}>
                RpcClient.config.url = "https://{window.location.hostname}.online/json.rpc"<br/>
                RpcClient.config.headers = &#123;&#125;;<br/>
                RpcClient.config.headers['Authorization'] = 'IoT <span className={classes.green}>{integrationDevice}</span>:EUeInvoices';<br/>
                RpcClient.call("Extension.Execute", &#123; extension: "EUeInvoices.<span className={classes.green}>{tx("DDDI_Save")}</span>", args: <span className={classes.red}>&lt;parameters&gt;</span> &#125;)<br/>
                <span className="ps-2">.done(res =&gt; &#123;<br/></span>
                <span className="ps-4">console.log(res);<br/></span>
                <span className="ps-4">&#125;)<br/></span>
                <span className="ps-2">.post()</span>
        </div>
        </>
    )
}

export default JSHowTo;